import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Card — surface primitive (MA-04)
 *
 * One elevation per surface (no card-in-card). Nesting another `Card` inside is an
 * antipattern: use border + background contrast on inner sections instead.
 */
import { forwardRef } from 'react';
import clsx from 'clsx';
const PADDING = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
};
const VARIANT = {
    flat: 'bg-neutral-0 border border-neutral-200 shadow-none',
    raised: 'bg-neutral-0 border border-neutral-100 shadow-md',
};
export const Card = forwardRef(({ variant = 'raised', padding = 'md', className, ...rest }, ref) => (_jsx("div", { ref: ref, className: clsx('rounded-lg text-neutral-900', VARIANT[variant], PADDING[padding], 'transition-shadow duration-fast ease-standard', className), ...rest })));
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map